module.exports = __webpack_public_path__ + "static/images/cimb.3yrFmi9.svg";